export const CompanyInfo = {
  name: 'Casy.js'
};

export const RoutesData = [
  {
    name: 'Home',
    component: 'Home',
    path: '/'
  },
  {
    name: 'Buttons',
    component: 'Buttons',
    path: '/buttons'
  },
  {
    name: 'Cards',
    component: 'Cards',
    path: '/cards'
  },
  {
    name: 'Navigation',
    component: 'Navigation',
    path: '/navigation'
  },
  {
    name: 'Landing Pages',
    component: 'LandingPages',
    path: '/landing-pages'
  },
  {
    name: 'Not Found',
    component: 'NotFound',
    path: null
  }
];



// WEBPACK FOOTER //
// ./src/DumbyData.js